export const STORE_KEYS = {
  UPLOAD_DATA: 'uploadData',
  REVIEW_DATA: 'review',
  STATUS_WIDGET: 'statusWidget',
  INFERENCE_DRAWER: 'inferenceDrawer',
  USER: 'user',
  MODEL_TRAINING: 'modelTraining',
  FILTER: 'filter',
  CREATE_DEFECT_DIALOG: 'createDefectDialog',
  USE_CASE: 'useCase',
  AI_PERFORMANCE: 'aiPerformance',
  SIMILAR_IMAGES_DIALOG: 'similarImages',
  SEGREGATE_IMAGES: 'segregateImages',
};
